import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Crosshair, Radio } from "lucide-react";
import { useLang } from "@/i18n";

export const Nav = () => {
  const [time, setTime] = useState("");
  const { lang, setLang, t } = useLang();

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      setTime(
        new Date(utc + 3600000).toLocaleTimeString("it-IT", { hour12: false })
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#28342C]/70 bg-[#0A0D0B]/80 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="px-3 sm:px-8 lg:px-16 h-14 sm:h-16 flex items-center justify-between gap-2 sm:gap-4">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-2 sm:gap-3 group shrink-0">
          <Crosshair className="w-4 h-4 sm:w-5 sm:h-5 text-[#C8B48D] group-hover:rotate-90 transition-transform duration-500" />
          <span className="font-mono2 text-[10px] sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] text-[#E6ECE8]">
            [KORPSECUR] <span className="text-[#9EACA2] hidden sm:inline">PRIVATE SECURITY</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-2 font-mono2 text-[11px] tracking-widest text-[#9EACA2]" data-testid="nav-status">
          <span className="w-2 h-2 rounded-full bg-[#22C55E] pulse-dot" />
          {t.nav.status}
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {t.nav.links.map((l) => (
            <a
              key={l.n}
              href={l.href}
              data-testid={`nav-link-${l.n}`}
              className="font-mono2 text-xs tracking-widest text-[#9EACA2] hover:text-[#E6ECE8] transition-colors duration-300"
            >
              <span className="text-[#C8B48D]">{l.n}.</span> {l.label.toUpperCase()}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-4">
          <div className="hidden sm:flex items-center gap-2 font-mono2 text-xs text-[#5C6A60]" data-testid="nav-clock">
            <Radio className="w-3.5 h-3.5" />
            UTC+1 <span className="text-[#C8B48D]">{time}</span>
          </div>
          <div className="flex items-center border border-[#28342C] chamfer-sm overflow-hidden" data-testid="lang-switcher">
            {["en", "it", "fr", "es"].map((l) => (
              <button
                key={l}
                data-testid={`lang-toggle-${l}`}
                onClick={() => setLang(l)}
                className={`font-mono2 text-[9px] sm:text-[10px] font-bold tracking-widest px-1.5 py-1 sm:px-2.5 sm:py-1.5 transition-colors duration-300 ${
                  lang === l ? "bg-[#5B7052] text-[#E6ECE8]" : "text-[#5C6A60] hover:text-[#9EACA2]"
                }`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a
            href="#contatti"
            data-testid="nav-cta-button"
            className="chamfer-sm bg-[#C8B48D] text-[#0A0D0B] font-mono2 text-[10px] sm:text-[11px] font-bold tracking-widest px-3 py-1.5 sm:px-4 sm:py-2 hover:bg-[#E6ECE8] transition-colors duration-300"
          >
            {t.nav.cta}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
